import React from "react";
import styles from "./Customers.module.css";
import Customer from "./Customer";
import TitleH2 from "../../../components/TitleH2/TitleH2";

import customerImg1 from "../../../assets/images/Customers/chapar.png";
import customerImg2 from "../../../assets/images/Customers/jeyoil.png";
import customerImg3 from "../../../assets/images/Customers/barname-budjeh.png";
import customerImg4 from "../../../assets/images/Customers/hamrah-e-aval.png";
import customerImg5 from "../../../assets/images/Customers/hormoz_logo.png";
import customerImg6 from "../../../assets/images/Customers/irtoya.png";
import customerImg7 from "../../../assets/images/Customers/naderi-logo.png";
import customerImg8 from "../../../assets/images/Customers/negin-car-logo.png";
import customerImg9 from "../../../assets/images/Customers/shabahang.webp";
import customerImg10 from "../../../assets/images/Customers/Ryoniz.jpg";
import customerImg11 from "../../../assets/images/Customers/akam bitumen.png";

function Customers({ title, description }) {
  const customers = [
    {
      id: 0,
      name: "چاپار",
      img: customerImg1,
      imageAlt: "chapaar company Logo",
    },
    {
      id: 1,
      name: "نفت جی",
      img: customerImg2,
      imageAlt: "Jay oil company Logo",
    },
    {
      id: 2,
      name: "برنامه بودجه",
      img: customerImg3,
      imageAlt: "barname bodje Logo",
    },
    {
      id: 3,
      name: "همراه اول",
      img: customerImg4,
      imageAlt: "Hamrahe aval communication Logo",
    },
    {
      id: 4,
      name: "هرمز",
      img: customerImg5,
      imageAlt: "Hormoz company logo",
    },
    {
      id: 5,
      name: "ایرتویا",
      img: customerImg6,
      imageAlt: "irtoya company logo",
    },

    {
      id: 6,
      name: "نادری",
      img: customerImg7,
      imageAlt: "naderi company logo",
    },
    {
      id: 7,
      name: "نگین خودرو",
      img: customerImg8,
      imageAlt: "negin car company logo",
    },
    {
      id: 8,
      name: "شباهنگ پرتو تابان",
      img: customerImg9,
      imageAlt: "shabahang company logo",
    },
    {
      id: 9,
      name: "ریونیز پالایش آرتان",
      img: customerImg10,
      imageAlt: "riyoniz logo",
    },
    {
      id: 10,
      name: "شرکت قیر آکام",
      img: customerImg11,
      imageAlt: "akam bitumen logo",
    },
  ];

  return (
    <>
      <section
        className={`${styles.customersSec}`}
        id="homePage-customers__sec">
        <div className={`${styles.customersCont}`}>
          <TitleH2>بعضی از مشتری‌ها</TitleH2>
          <div className={`${styles.customers}`}>
            {[...customers, ...customers].map((e, index) => (
              <Customer key={index} name={e.name} img={e.img} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Customers;
